<template>
  <v-app class="modern-scrollbar">
    <v-main>
      <router-view />
      <snt-overlay-loading :loading="isLoading" />
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  data () {
    return {
      apiUrl: process.env.VUE_APP_API
    }
  },
  computed: {
    ...mapGetters({
      userId: 'auth/userId',
      shopName: 'auth/shopName',
      isLoading: 'app/isLoading'
    })
  }
}
</script>

<style lang="scss">
  @import '~@/assets/scss/styles.scss';
  @import '~@/assets/scss/vuetify.scss';
</style>
